<header class="modal-header header">
    {{ Localization.Filter | translate }}
    <a (click)="cancel()" aria-label="Close" class="close pull-right">
        <span aria-hidden="true">×</span>
    </a>
</header>
<main>
    <chapps-select-input [control]="jobTypeField"
                         [items]="jobTypeOptions"
                         [label]="Localization.JobType"
    ></chapps-select-input>
</main>

<footer class="modal-footer justify-content-end">
    <chapps-secondary-button (clicked)="applyFilters()"
                             [label]="Localization.Filter"
                             [small]="true"></chapps-secondary-button>
</footer>
